/**
 * Get filtered photos
 * @param {string} filterName
 * @param {string} filterValue
 * @param {array} photos
 * @returns {array}
 */
export default function getFilteredPhotos(
  filterName = "",
  filterValue = "",
  photos = []
) {
  return photos.filter(photo => {
    if (!filterValue) {
      return true;
    }

    if (
      filterName === "description" &&
      !!photo.description &&
      photo.description.toUpperCase() === filterValue
    ) {
      return true;
    }

    if (
      filterName === "source" &&
      !!photo.source &&
      photo.source.toUpperCase() === filterValue
    ) {
      return true;
    }

    if (
      filterName === "taskName" &&
      !!photo.taskName &&
      photo.taskName.toUpperCase() === filterValue
    ) {
      return true;
    }

    return false;
  });
}
